// @ts-nocheck

export const localeCodes =  [
  "de",
  "en",
  "fr",
  "it"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_45DE_46json_3d7f9003",
      load: () => import("#nuxt-i18n/3d7f9003" /* webpackChunkName: "locale_de_45DE_46json_3d7f9003" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45GB_46json_c7289086",
      load: () => import("#nuxt-i18n/c7289086" /* webpackChunkName: "locale_en_45GB_46json_c7289086" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_a998a106",
      load: () => import("#nuxt-i18n/a998a106" /* webpackChunkName: "locale_fr_45FR_46json_a998a106" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_91a0b738",
      load: () => import("#nuxt-i18n/91a0b738" /* webpackChunkName: "locale_it_45IT_46json_91a0b738" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    iso: "de-DE",
    name: "Deutsch",
    isCatchallLocale: true,
    language: undefined
  },
  {
    code: "en",
    iso: "en-GB",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    iso: "fr-FR",
    name: "Français",
    language: undefined
  },
  {
    code: "it",
    iso: "it-IT",
    name: "Italiano",
    language: undefined
  }
]

